<template>
  <nav class="header-menu" v-if="$store.state.global.screenWidth > 776">
    <ul>
      <li v-for="item in items"><a :href="item.url" :class="item.params?.pink === 'Y' ? 'pink' : ''">{{item.title}}</a></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "HeaderMenu",
  selector: ".header-menu",
  props: {items: Object}
}

</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
.header-menu {
  background: #f7f7f7;
  margin-top: 2px;
  float: left;
  width: 100%;

  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 35px;
    width: 100%;

    li {
      flex: 0 0 auto;
    }
  }

  a {
    font-family: "Inter", "TOUS", sans-serif;
    display: inline-block;
    padding: 10px 0;
    text-decoration: none;
    color: #000;
    font-weight: bold;
    transition: color 0.2s ease;

    &:hover {

    }
  }

  a.pink {
    color: #ff69b4 !important;
  }
}
</style>